import { ClientPaymentCardViewModel } from '@common/model/client/billing/paymentCardView';
import { alpha } from '@mui/system/colorManipulator';
import { PaymentSystemIcon } from '@cp/ds/src/icons/payment';
import React from 'react';
import { styled } from '@cp/ds/src/theme';
import { formatPaymentCardNumber } from '@cp/shared/lib/payment';
import { Typography } from '@cp/ds/src/components/typography';
import { Box, BoxProps } from '@cp/ds/src/components/box';

const name = 'PaymentCard';
const Root = styled(Box, { name })({
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
});
const System = styled(Box, { name, slot: 'system' })(({ theme }) => ({
  width: '80px',
  height: '40px',
  backgroundColor: alpha(theme.palette.gray, 0.1),
  borderRadius: '6px',
  overflow: 'hidden',
  position: 'relative',
}));

export interface PaymentCardProps extends Pick<ClientPaymentCardViewModel, 'pan' | 'system'>, BoxProps {}
export const PaymentCard: React.FC<PaymentCardProps> = ({ system, pan, sx }) => {
  return (
    <Root sx={sx}>
      <System>
        <PaymentSystemIcon
          fontSize="60px"
          paymentSystem={system}
          sx={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }}
        />
      </System>
      <Typography>{formatPaymentCardNumber(pan)}</Typography>
    </Root>
  );
};
